<div class="spacer"></div>
<section #headerMobile id="header" class="header">
    <div class="container-mobile-menu shadow-sm">
        <div class="row">
            <div class="col-3 col-md-4">
                <div class="w-100 d-flex">
                    <a class="header-sub-item-icon" (click)="toggleMenu()">
                        <svg-icon src="assets/images/icon-menu.svg"></svg-icon>
                    </a>
                    <a class="header-sub-item-icon me-0"
                       gaEvent="click_email_address" gaCategory="Contact" gaBind="click"
                       fbqEvent="click_email_address" fbqBind="click"
                       href="tel:{{(publicTelNo$ | async)}}">
                        <svg-icon src="assets/images/icon-phone.svg"></svg-icon>
                    </a>
                </div>
            </div>
            <div class="col-6 col-md-4 mx-auto d-flex flex-column align-items-center">
                <a *ngIf="!router.isActive('/account',false)" [routerLink]="['/']">
                    <svg-icon src="assets/images/ys-logo-text.svg" [svgClass]="'header__logo-img'"></svg-icon>
                </a>
                <a *ngIf="router.isActive('/account',false)" [routerLink]="['/']" class="text-center">
                    <svg-icon *ngIf="router.isActive('/account',false)"
                              src="assets/images/ys-logo-icon.svg"
                              [svgClass]="'header__logo-img--icon'"></svg-icon>
                </a>
            </div>
            <div *ngIf="!(user$ | async)" class="col-3 col-md-4">
                <div class="w-100 d-flex justify-content-end">
                    <a class="header-sub-item-icon " [routerLink]="['/basket']">
                        <svg-icon src="assets/images/icon-cart.svg"></svg-icon>
                        <div class="badge-count"
                             *ngIf="(basket$ | async).items.length || (basket$ | async).samples.length">{{(basket$ | async).items.length + (basket$ | async).samples.length}}</div>
                    </a>
                     <a appDropdown class="header-sub-item-icon me-0 dropdown" href="javascript:void(0)">
                        <svg-icon src="assets/images/icon-user.svg"></svg-icon>
                        <div class="dropdown-menu dropdown-menu-end dropdown-menu-user shadow-sm px-4 py-3">
                            <a [routerLink]="['/login']"
                               class="dropdown-item fw-bold text-primary small px-0 mb-2">
                                Sign in
                            </a>
                            <a [routerLink]="['/register']"
                               class="dropdown-item fw-bold text-primary px-0 small mb-2">
                                Create account
                            </a>
                            <div class="dropdown-divider mt-0 mb-2"></div>
                            <a [routerLink]="['/my-favourites']"
                               class="dropdown-item fw-bold text-primary small px-0">
                                Favourites
                            </a>
                        </div>
                    </a>
                </div>
            </div>
            <div *ngIf="(user$ | async)" class="col-3 col-md-4">
                <div class="w-100 d-flex justify-content-end">
                    <a *ngIf="(deviceType$| async) !== 'mobile'" [routerLink]="['/my-favourites']"
                       class="header-sub-item-icon">
                        <svg-icon src="assets/images/icon-heart.svg"></svg-icon>
                        <span class="badge-count"
                              *ngIf="(favourites$ | async).length">{{(favourites$ | async).length}}</span>
                    </a>
                    <!--
                    <a class="header-sub-item-icon d-none d-md-flex" (click)="toggleNotifications()">
                        <svg-icon src="assets/images/icon-bell.svg"></svg-icon>
                        <div class="badge-count"
                             *ngIf="(notifications$ | async).unread > 0">{{(notifications$ | async).unread}}</div>
                    </a>
                    <a class="header-sub-item-icon d-none d-md-flex" [routerLink]="['/account', 'mail']">
                        <svg-icon src="assets/images/icon-chat.svg"></svg-icon>
                        <div class="badge-count" *ngIf="(chatStore$ | async).unread">{{(chatStore$ | async).unread}}</div>
                    </a>
                    -->
                    <a class="header-sub-item-icon" [routerLink]="['/basket']">
                        <svg-icon src="assets/images/icon-cart.svg"></svg-icon>
                        <div class="badge-count"
                             *ngIf="(basket$ | async).items.length || (basket$ | async).samples.length">{{(basket$ | async).items.length + (basket$ | async).samples.length}}</div>
                    </a>
                    <a class="header-sub-item-icon me-0" (click)="toggleMenuUser()">
                        <svg-icon src="assets/images/icon-user.svg"></svg-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<!--<app-promo-bar *ngIf="showPromoBar"></app-promo-bar>-->

<!--
<app-confirmation *ngIf="confirmationData.open" [data]="confirmationData"
                  (complete)="confirmationComplete($event)"></app-confirmation>-->
